import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit';
import { style } from './zui-button-group-css.js';

/**
 * Groups related actions into a combined presentation. Use with `<zui-button>` or `<zui-button-dropdown>` elements.
 *
 * @element zui-button-group
 *
 * @slot - Default, unnamed slot; for inserting `<zui-button>`, `<zui-button-dropdown>`, `<a>`, and `<button>` elements into `<zui-button-group>`
 */
export class ZuiButtonGroup extends ZuiBaseElement {
  static get styles() {
    return [super.styles, style];
  }

  render() {
    return html`
      <div class="zui-button-group">
        <slot></slot>
      </div>
    `;
  }
}

window.customElements.define('zui-button-group', ZuiButtonGroup);

declare global {
  interface HTMLElementTagNameMap {
    'zui-button-group': ZuiButtonGroup;
  }
}
